import { Button, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  dialogSurface: {
    width: "400px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
});

interface ActivityDeactivationWarningDialogProps {
  isOpen: boolean;
  onClose: () => void;
  warningType: "subActivities" | "mirroredChildren";
}

export const ActivityDeactivationWarningDialog = (
  props: ActivityDeactivationWarningDialogProps
) => {
  const { isOpen, onClose, warningType } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const getTitle = () => {
    switch (warningType) {
      case "subActivities":
        return t("deactivateActivityWithSubActivitiesTitle");
      case "mirroredChildren":
        return t("deactivateActivityWithMirroredChildrenTitle");
      default:
        return "";
    }
  };

  const getMessage = () => {
    switch (warningType) {
      case "subActivities":
        return t("deactivateActivityWithSubActivitiesMessage");
      case "mirroredChildren":
        return t("deactivateActivityWithMirroredChildrenMessage");
      default:
        return "";
    }
  };

  return (
    <div aria-hidden={!isOpen}>
      <div className={classes.dialogSurface}>
        <h4>{getTitle()}</h4>
        <div>
          <div className={classes.content}>{getMessage()}</div>
        </div>
        <div>
          <Button appearance="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};
